import { useState, useEffect, useCallback } from "react"
import { fetchFollowUps } from "../api/followUpsApi"

// Follow-ups scoped to a lead/deal detail page.
export function useFollowUps({ parentType, parentId }) {
  const [followUps, setFollowUps] = useState(null)
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    if (!parentId) return
    setLoading(true)
    try {
      setFollowUps(await fetchFollowUps(parentType, parentId))
    } catch {
      setFollowUps([])
    } finally {
      setLoading(false)
    }
  }, [parentType, parentId])

  useEffect(() => { load() }, [load])

  return { followUps, loading, refresh: load, setFollowUps }
}
